// extracted by mini-css-extract-plugin
module.exports = {"numberBadge":"NumberBadge_numberBadge__1eOKq"};